<template>
    <div class="app-container">
        <breadcrumb-fe :navSource="nav_source"></breadcrumb-fe>
        <tabs ref="tabs" :tab-name="stageNames"></tabs>
        <score-tabs ref="stabs" :tab-name="stageName" :school_uuid="school_uuid"></score-tabs>
        <tab-year @func="handleTabYear" ref="year"></tab-year>

        <div class="filter-container">
            <el-select
                clearable
                style="width: 150px"
                class="filter-item"
                v-model="listQuery.way"
                placeholder="学习形式"
            >
                <el-option
                    v-for="item in wayOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
            <el-select
                clearable
                style="width: 150px"
                class="filter-item"
                v-model="listQuery.ex_type"
                placeholder="考试方式"
            >
                <el-option
                    v-for="item in exTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
            <el-input
                style="width: 150px;"
                class="filter-item"
                placeholder="报考院系"
                v-model="listQuery.department"
            ></el-input>
            <el-input
                style="width: 200px;"
                class="filter-item"
                placeholder="专业代码或名称"
                v-model="listQuery.major"
            ></el-input>

            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
            >搜索</el-button>
        </div>

        <el-table
            :data="list"
            v-loading="listLoading"
            element-loading-text="加载中 ..."
            border
            highlight-current-row
            max-height="550"
        >
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column label="院系所" width="160" prop="department" show-overflow-tooltip></el-table-column>
            <el-table-column label="专业代码及名称" width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <router-link
                        class="link"
                        :to="'/apply/major-info/' + scope.row.major_uuid"
                        target="_blank"
                    >{{ scope.row.major }}</router-link>
                </template>
            </el-table-column>
            <el-table-column label="学习形式" width="100" align="center" prop="get_way_display"></el-table-column>
            <el-table-column label="考试方式" width="100" align="center" prop="ex_type"></el-table-column>

            <el-table-column label="政治平均分" width="100" align="center" prop="polity_avg"></el-table-column>
            <el-table-column label="外国语平均分" width="120" align="center" prop="language_avg"></el-table-column>
            <el-table-column label="业务课一平均分" width="120" align="center" prop="subject1_avg"></el-table-column>
            <el-table-column label="业务课二平均分" width="120" align="center" prop="subject2_avg"></el-table-column>
            <el-table-column label="最低分" width="80" align="center" prop="lowest"></el-table-column>
            <el-table-column label="最高分" width="80" align="center" prop="highest"></el-table-column>
            <el-table-column label="平均分" min-width="80" prop="average"></el-table-column>
        </el-table>
        <div class="pagination-container">
            <pagination
                :total="count"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.size"
                @pagination="fetchData(yearName)"
            />
        </div>
    </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import BreadcrumbFe from "@/components/BreadcrumbFe";
import Tabs from "./components/Tabs";
import ScoreTabs from "./components/ScoreTabs";
import TabYear from "@/components/TabYear";
import { getScoreSummary,getSchoolDetail } from "@/api/apply";

export default {
    name: "ReexamineScoreLine",
    data() {
        return {
            school_uuid: "",
            yearName: "",
            list: null,
            count: 0,
            listLoading: true,
            nav_source: null,
            stageNames: 'school-line',
            stageName: "reexamine-line",
            school_name: "",
            school_path: "",
            listQuery: {
                page: 1,
                size: 50,
                way: "",
                department: "",
                major: ""
            },
            wayOptions: [
                { label: "全日制", value: 1 },
                { label: "非全日制", value: 2 }
            ],
            exTypeOptions: [
                { label: "全国统考 ", value: 1 },
                { label: "单独考试", value: 3 }
            ]
        };
    },
    components: {
        BreadcrumbFe,
        Tabs,
        ScoreTabs,
        TabYear
    },
    created() {
      this.school_uuid = this.$route.params.school_uuid;
      getSchoolDetail(this.school_uuid).then((res) => {
        this.nav_source = [
          { title: res.data.name, path: '/apply/attribute/' + this.school_uuid, },
          { title: '分数信息', path: '' }
        ];
      });
    },
    methods: {
        checkPermission,
        handleTabYear(year) {
            this.yearName = year;
            Object.assign(this.listQuery, {
                page: 1,
                way: "",
                department: "",
                major: ""
            });
            this.fetchData(year);
        },
        fetchData(year) {
            getScoreSummary(this.school_uuid, year, 1, this.listQuery).then(
                res => {
                    this.list = res.data.results;
                    this.count = res.data.count;
                    this.listLoading = false;
                }
            );
        },
        // 筛选
        handleFilter() {
            Object.assign(this.listQuery, {
                page: 1
            });
            this.fetchData(this.yearName);
        }
    }
};
</script>
<style lang="less" scoped>
.app-container {
    padding-top: 10px;
}

.link {
    color: #409eff;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
        cursor: pointer;
    }
}
</style>

